<script setup>
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';

const { t } = useI18n();
const { updateUISettings } = useUISettings();

const replayTips = () => {
  // Só limpa persistência: o PageCoach no Dashboard reage ao ui_settings.
  updateUISettings({ page_coach: { seen: {}, disabled: false } });
  useAlert(t('ONBOARDING.REPLAY_SUCCESS'));
};

const replayTours = () => {
  updateUISettings({ guided_tours: {} });
  useAlert(t('ONBOARDING.TOURS.REPLAY_SUCCESS'));
};
</script>

<template>
  <div class="flex flex-wrap items-center justify-end gap-2 py-2">
    <button
      type="button"
      class="min-h-9 shrink-0 rounded-full border border-n-weak px-4 text-sm font-semibold text-n-slate-12 hover:bg-n-alpha-2"
      data-testid="page-coach-replay"
      @click="replayTips"
    >
      {{ t('ONBOARDING.REPLAY_BUTTON') }}
    </button>
    <button
      type="button"
      class="min-h-9 shrink-0 rounded-full border border-n-weak px-4 text-sm font-semibold text-n-slate-12 hover:bg-n-alpha-2"
      data-testid="guided-tour-replay-all"
      @click="replayTours"
    >
      {{ t('ONBOARDING.TOURS.REPLAY_BUTTON') }}
    </button>
  </div>
</template>
